module.exports = __webpack_public_path__ + "img/celebration-spark.8339377c.png";